import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { AccountsListPage } from './AccountsListPage';
import { AccountAddPage } from './AccountAddPage';
import { AccountsForReviewPage } from './AccountsForReviewPage';
import { AssignAgentPage } from './AssignAgentPage';
export const AccountsPage = ({ isExpanded }) => (
  <Routes>
    <Route
      path=""
      element={<AccountsListPage isExpanded={isExpanded} />}
    />
    <Route
      path="add"
      element={<AccountAddPage isExpanded={isExpanded} />}
    />
    <Route
      path="accounts-for-review"
      element={<AccountsForReviewPage isExpanded={isExpanded} />}
    />
    <Route
      path="assign-agent/:id"
      element={<AssignAgentPage isExpanded={isExpanded} />}
    />
  </Routes>
);

AccountsPage.propTypes = {
  isExpanded: propTypes.bool.isRequired,
};
